import router from '@/router'
import getPageTitle from '@/utils/getPageTitle'

router.afterEach((to) => {
    document.title = getPageTitle(to.meta.title)
})
